import { createApp } from 'vue';
import AvifToGifConverter from '../Components/AvifToGifConverter.vue';

const root = document.getElementById('avif-to-gif-converter');
if (root) {
  createApp(AvifToGifConverter).mount('#avif-to-gif-converter');
}
